// src/Auth0ProviderWithNavigate.jsx
import { Auth0Provider } from "@auth0/auth0-react";

// A configuração do SPA é pública — domain, clientId e audience vão no bundle e
// qualquer um lê no navegador. Por isso ela mora aqui, e não em variável de
// ambiente: o CRA embute REACT_APP_* em tempo de BUILD, e como o build/ é
// versionado, um bundle gerado com o .env local acabava publicado apontando para
// o tenant errado. Foi assim que produção rodou contra homologação.
//
// Decidindo pelo hostname em runtime, o mesmo bundle funciona nos dois lugares e
// não existe "build errado": quem escolhe é o navegador ao abrir a página.
const AMBIENTES = {
  // Tenant dedicado ao OneWork, acessado pelo custom domain.
  // O Management API do backend continua no dominio canonico
  // (one-work.us.auth0.com) — ver AUTH0_MGMT_AUDIENCE no back.
  producao: {
    domain: "auth.onework.com.br",
    clientId: "6iloq6iGvheU6asZWxYYeCK484PfejMr",
    audience: "https://api.onework.com.br/",
  },
  // Tenant de homologação da Contabilidade.com, usado no desenvolvimento local.
  // O backend local precisa apontar para o MESMO tenant (ver .env do back), senão
  // o token vem com issuer/audience que ele não valida.
  local: {
    domain: "idp-hml.contabilidade.com",
    clientId: "bbq18H66SMJcGnMGvV4FDVJCRtnrAnUq",
    audience: "https://api.contabilidadeonline.com.br",
  },
};

const ehLocal = ["localhost", "127.0.0.1"].includes(window.location.hostname);
const config = ehLocal ? AMBIENTES.local : AMBIENTES.producao;

const Auth0ProviderWithNavigate = ({ children }) => (
  <Auth0Provider
    domain={config.domain}
    clientId={config.clientId}
    authorizationParams={{
      redirect_uri: window.location.origin + "/auth/token",
      audience: config.audience,
    }}
  >
    {children}
  </Auth0Provider>
);

export default Auth0ProviderWithNavigate;
